import { useSettingsStore } from '../store/settings';

export function useAllowedExternalDaypass() {
  return useSettingsStore().isDayPassEnabled;
}

export function useIsSameExternalDaypassOption(type: 'flex' | 'reserved') {
  const { dayPassOption } = useSettingsStore();
  return type === dayPassOption;
}
